<template>
    <!-- 正文内容 -->
    <div class="poem-content">
        <!-- 标题 -->
        <div class="title">{{poem.title}}</div>
        <!-- 作者 -->
        <div class="poet">
            <!-- 朝代 -->
            <div class="dynasty">{{poet.dynasty.substring(0,1)}}</div>
            <!-- 姓名 -->
            <div class="name">{{poet.name}}</div>
        </div>
        <!-- 正文 -->
        <div class="content" v-html="formatHtml(poem.content)"></div>
        <!-- 标签 -->
        <div class="tags">
            <div class="tag" v-for="tag in tags" @click="$router.push('/tagPage/'+tag.id+'/'+tag.name)">{{tag.name}}</div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    export default {
        name: "Content",
        props:["poem","poet","tags"],
        mounted(){

        },
        data(){
            return{

            }
        },
        methods:{
            formatHtml(value){
                let toHtml = Vue.filter("toHtml");
                return toHtml(value);
            }
        }
    }
</script>

<style scoped lang="less">
    .poem-content{
        width: 60%;
        margin: 30px auto;
        background-color: white;
        padding: 35px;
        box-sizing: border-box;
        text-align: center;
        border-radius: 15px;
        box-shadow: 0 2px 2px rgba(10,16,20,.24),0 0 2px rgba(10,16,20,.25);
        /* 背景图设置 */
        background-image: url("../../../../assets/texture.png"),url("../../../../assets/mei.png"),url("../../../../assets/he.png");
        background-size: auto,14%,18%;
        background-position: left top,right top,left bottom;
        background-repeat: repeat,no-repeat,no-repeat;
        /* 标题 */
        .title{
            font-size: 22px;
            font-weight: bold;
            line-height: 30px;
            letter-spacing: 1px;
            color: #DD4455;
        }
        /* 作者 */
        .poet{
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            line-height: 25px;
            height: 42px;
            font-family: 楷体,宋体;
            /* 朝代 */
            .dynasty{
                height: 42px;
                width: 42px;
                background-size: cover;
                line-height: 45px;
                color: white;
                text-align: center;
                background-image: url("../../../../assets/time-yin.png");
            }
            /* 姓名 */
            .name{
                letter-spacing: 2px;
            }
        }
        /* 正文 */
        .content{
            margin: 15px auto;
            font-family: 楷体,宋体;
            font-size: 25px;
            color: black;
            text-shadow: 0 0 0 rgb(0 0 0 / 20%);
            line-height: 40px;
            font-weight: bold;
        }
        /* 标签 */
        .tags{
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            width: 60%;
            margin: 15px auto;
            font-family: 楷体,宋体;
            font-size: 19px;
            /* 单个标签样式 */
            .tag{
                margin-left: 15px;
                margin-top: 10px;
                padding: 7px;
                color: #DD4455;
                background-color: rgba(255, 225, 225);
                border-radius: 18px;
                cursor: pointer;
                user-select: none;
                font-weight: bold;
            }
            .tag:hover{
                color: #BB4455;
            }
        }
    }

</style>